<template>
  <Loader v-if="loading" />
  <div class="gestisci-pratica">
    <div class="header-section">
      <h2 class="page-title">Gestione Pratiche</h2>
      <p class="subtitle">Gestione e tracciamento delle pratiche</p>
    </div>

    <div class="card-container">
      <TabView v-model:activeIndex="activeTabIndex" selectOnFocus class="tab-container">
        <TabPanel>
          <template #header>
            <div class="tab-header">
              <span class="tab-title">Switch</span>
              <div class="badge-container">
                <Badge :value="countPreSwitchPod" size="large" severity="warning"/>
                <span class="badge-separator">+</span>
                <Badge :value="countPreSwitchPdr" size="large"/>
              </div>
            </div>
          </template>
          
          <div class="tab-content">
            <Accordion :multiple="true" :activeIndex="[0]" class="custom-accordion">
              <AccordionTab header="Gestisci Switch">
                <Switchin />
              </AccordionTab>
              
              <AccordionTab header="Gestisci Accettazioni">
                <SwitchinCaricati />
              </AccordionTab>
              
              <AccordionTab header="Gestisci TIMOE/TIMG">
                <TIMOE_TIMG />
              </AccordionTab>
            </Accordion>
          </div>
        </TabPanel>
        
        <!-- Placeholder per la sezione Precheck (commentata) -->
        <TabPanel>
          <template #header>
            <div class="tab-header">
              <span class="tab-title">Precheck</span>
              <div class="badge-container">
                <Badge :value="countPrecheckPod" size="large" severity="warning"/>
                <span class="badge-separator">+</span>
                <Badge :value="countPrecheckPdr" size="large"/>
              </div>
            </div>
          </template>
          
          <div class="tab-content">
            <div class="download-section" v-if="countPrecheckPod || countPrecheckPdr">
              <div class="download-card" v-if="countPrecheckPod">
                <Button label="Scarica file Precheck energia" 
                  :disabled="downloadedPk" 
                  icon="pi pi-cloud-download" 
                  @click="downloadPrecheckFile('ee')" 
                  class="p-button-raised p-button-warning download-button"/>
              </div>
              
              <div class="download-card" v-if="countPrecheckPdr">
                <Button label="Scarica file Precheck gas" 
                  :disabled="downloadedPk" 
                  icon="pi pi-cloud-download" 
                  @click="downloadPrecheckFile('gas')" 
                  class="p-button-raised download-button"/>
              </div>
            </div>

            <div class="file-info" v-if="downloadedPk">
              <div class="file-details">
                <div class="file-name">
                  <span class="label">File generato:</span>
                  <span class="value">Precheck {{ filename.startsWith('PKG') ? 'Gas' : 'Energia'}} <strong>{{ filename }}</strong></span>
                </div>
                
                <div class="input-section">
                  <label for="id_pratica_pk" class="input-label">Inserisci l'Id della richiesta</label>
                  <InputMask id="id_pratica_pk" v-model="id_pratica_pk" mask="9999999" class="input-mask"/>
                </div>
                
                <div class="action-button">
                  <Button icon="pi pi-link" 
                    label="Salva l'ID della richiesta" 
                    @click="saveIdPratica('pk')" 
                    :disabled="id_pratica_pk == ''" 
                    class="p-button-primary"/>
                </div>
              </div>
            </div>

            <div class="data-table-section" v-if="itemsPk && itemsPk.length > 0">
              <div class="section-header">
                <h3>Elenco richieste Precheck</h3>
              </div>
              
              <DataTable :value="itemsPk" 
                :sortOrder="-1" 
                sortField="data_creazione" 
                paginator 
                :rows="10" 
                :rowsPerPageOptions="[5, 10, 20, 50]" 
                breakpoint="1190px"
                class="custom-datatable">
                <template #empty>
                  <div class="empty-message">Nessun dato disponibile</div>
                </template>
                
                <Column field="filename" header="File di richiesta">
                  <template #body="{data}">
                    <Button :label="data.filename" 
                      v-if="!data.id_richiesta" 
                      class="file-button" 
                      v-tooltip="'Scarica file di richiesta'" 
                      @click="downloadPrecheckFile(data.filename.startsWith('PKG1') ? 'gas' : 'ee', data.filename)" 
                      icon="pi pi-download" 
                      severity="info"/>
                    <p v-else class="file-name-text">
                      {{ data.filename}}
                    </p>
                  </template>
                </Column>
                
                <Column field="total" header="PdP">
                  <template #body="{data}">
                    <p v-tooltip="`${data.codes}`" class="pdp-count">{{ data.total }}</p>
                  </template>
                </Column>
                
                <Column field='data_creazione' header="Data Creazione" :sortable="true">
                  <template #body="{data}">
                    <span class="date-value">{{moment(data.data_creazione).format('DD-MM-YYYY HH:mm')}}</span>
                  </template>
                </Column>
                
                <Column field="ID richiesta" header="ID richiesta">
                  <template #body="{data, index}">
                    <InputMask v-if="data.id_richiesta == null" 
                      v-model="id_pratica_pk_insert[index]" 
                      mask="9999999" 
                      class="id-input"/>
                    <p v-else class="id-value"> {{ data.id_richiesta }} </p>
                  </template>
                </Column>
                
                <Column field='processed' header="Completo">
                  <template #body="{data}">
                    <span v-if="data.processed" class="status-icon completed">
                      <i class="pi pi-check" aria-hidden="true"></i>
                    </span>
                    <span v-else class="status-icon pending">
                      <i class="pi pi-ban" aria-hidden="true"></i>
                    </span>
                  </template>
                </Column>
                
                <Column field='data_elaborazione' header="Data Elaborazione" :sortable="true">
                  <template #body="{data}">
                    <span class="date-value">{{data.data_elaborazione ? moment(data.data_elaborazione).format('DD-MM-YYYY HH:mm') : '--'}}</span>
                  </template>
                </Column>

                <Column :exportable="false">
                  <template #body="{data, index}">
                    <FileUpload class="upload-button" 
                      v-if="!data.processed && data.id_richiesta" 
                      :key="fileUploadKeyPK" 
                      mode="basic" 
                      :auto="true" 
                      accept=".csv" 
                      name="filePKToUpload[]" 
                      customUpload 
                      @uploader="uploadResponsePratica($event, data.id_richiesta, 'pk', data.filename.startsWith('PKG1') ? 'Gas' : 'Energia')" 
                      chooseLabel="Carica Esito" />
                    <Button class="download-result-button" 
                      v-if="data.processed" 
                      label="Scarica esito" 
                      icon="pi pi-cloud-download" 
                      @click="downloadResponsePrecheckFile($event, data.id_richiesta, data.filename.startsWith('PKG1') ? 'Gas' : 'Energia')" 
                      severity="success"/>
                    <Button class="save-id-button" 
                      v-if="!data.id_richiesta && (id_pratica_pk_insert[index] != null && id_pratica_pk_insert[index] != '')" 
                      icon="pi pi-link" 
                      label="Salva l'ID della richiesta" 
                      :disabled="id_pratica_pk_insert[index] == ''" 
                      @click="saveIdPratica('pk', data.filename, id_pratica_pk_insert[index], index)"/>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </TabPanel>

        <!-- Placeholder per la sezione Informativa Voltura (commentata) -->
        <TabPanel>
          <template #header>
            <div class="tab-header">
              <span class="tab-title">Informativa Voltura</span>
              <div class="badge-container">
                <Badge :value="countIvPod" size="large" severity="warning"/>
                <span class="badge-separator">+</span>
                <Badge :value="countIvPdr" size="large"/>
              </div>
            </div>
          </template>
          
          <div class="tab-content">
            <div class="download-section" v-if="countIvPod || countIvPdr">
              <div class="download-card" v-if="countIvPod">
                <Button label="Scarica file Informativa Voltura Energia" 
                  :disabled="countIvPod == 0" 
                  icon="pi pi-cloud-download" 
                  @click="downloadIvFile('ee')" 
                  class="p-button-raised p-button-warning download-button"/>
              </div>
              <div class="download-card" v-if="countIvPdr">
                <Button label="Scarica file Informativa Voltura Gas" 
                  :disabled="countIvPdr == 0" 
                  icon="pi pi-cloud-download" 
                  @click="downloadIvFile('gas')" 
                  class="p-button-raised download-button"/>
              </div>
            </div>

            <div class="file-info" v-if="downloadedIv">
              <div class="file-details">
                <div class="input-section">
                  <label for="id_pratica_iv" class="input-label">Inserisci l'Id della richiesta</label>
                  <InputMask id="id_pratica_iv" v-model="id_pratica_iv" mask="9999999" class="input-mask"/>
                </div>
                
                <div class="action-button">
                  <Button icon="pi pi-link" 
                    label="Salva l'ID della richiesta" 
                    @click="saveIdPratica('iv')" 
                    :disabled="id_pratica_iv == ''" 
                    class="p-button-primary"/>
                </div>
              </div>
            </div>
            
            <div class="data-table-section" v-if="itemsIv && itemsIv.length > 0">
              <div class="section-header">
                <h3>Elenco richieste Informativa Voltura</h3>
              </div>
              
              <DataTable :value="itemsIv" 
                :sortOrder="-1" 
                sortField="data_creazione" 
                paginator 
                :rows="10" 
                :rowsPerPageOptions="[5, 10, 20, 50]"
                class="custom-datatable">
                <template #empty>
                  <div class="empty-message">Nessun dato disponibile</div>
                </template>
                
                <Column field="filename" header="File di richiesta">
                  <template #body="{data}">
                    <Button :label="data.filename" 
                      v-if="!data.id_richiesta" 
                      class="file-button" 
                      v-tooltip="'Scarica file di richiesta'" 
                      @click="downloadIvFile(data.filename.startsWith('IVG1') ? 'gas' : 'ee', data.filename)" 
                      icon="pi pi-download" 
                      severity="info"/>
                    <p v-else class="file-name-text">
                      {{ data.filename}}
                    </p>
                  </template>
                </Column>
                
                <Column field="total" header="PdP">
                  <template #body="{data}">
                    <p v-tooltip="`${data.codes}`" class="pdp-count">{{ data.total }}</p>
                  </template>
                </Column>
                
                <Column field='data_creazione' header="Data Creazione" :sortable="true">
                  <template #body="{data}">
                    <span class="date-value">{{moment(data.data_creazione).format('DD-MM-YYYY HH:mm')}}</span>
                  </template>
                </Column>

                <Column field="ID richiesta" header="ID richiesta">
                  <template #body="{data, index}">
                    <InputMask v-if="data.id_richiesta == null" 
                      v-model="id_pratica_iv_insert[index]" 
                      mask="9999999" 
                      class="id-input"/>
                    <p v-else class="id-value"> {{ data.id_richiesta }} </p>
                  </template>
                </Column>
                
                <Column field='processed' header="Completo">
                  <template #body="{data}">
                    <span v-if="data.processed" class="status-icon completed">
                      <i class="pi pi-check" aria-hidden="true"></i>
                    </span>
                    <span v-else class="status-icon pending">
                      <i class="pi pi-ban" aria-hidden="true"></i>
                    </span>
                  </template>
                </Column>
                
                <Column field='data_elaborazione' header="Data Elaborazione" :sortable="true">
                  <template #body="{data}">
                    <span class="date-value">{{data.data_elaborazione ? moment(data.data_elaborazione).format('DD-MM-YYYY HH:mm') : '--'}}</span>
                  </template>
                </Column>

                <Column :exportable="false">
                  <template #body="{data, index}">
                    <FileUpload class="upload-button" 
                      v-if="!data.processed && data.id_richiesta" 
                      :key="fileUploadKeyIV" 
                      mode="basic" 
                      :auto="true" 
                      accept=".csv" 
                      name="fileIVToUpload[]" 
                      customUpload 
                      @uploader="uploadResponsePratica($event, data.id_richiesta, 'iv', data.filename.startsWith('IVG1') ? 'Gas' : 'Energia')" 
                      chooseLabel="Carica Esito" />
                    <Button class="download-result-button" 
                      v-if="data.processed" 
                      label="Scarica esito" 
                      icon="pi pi-cloud-download" 
                      @click="downloadResponseIvFile($event, data.id_richiesta)" 
                      severity="success"/>
                    <Button class="save-id-button" 
                      v-if="!data.id_richiesta && (id_pratica_iv_insert[index] != null && id_pratica_iv_insert[index] != '')" 
                      icon="pi pi-link" 
                      label="Salva l'ID della richiesta" 
                      :disabled="id_pratica_iv_insert[index] == ''" 
                      @click="saveIdPratica('iv', data.filename, id_pratica_iv_insert[index], index)"/>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </TabPanel>
      </TabView>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useRouter } from 'vue-router'
import moment from 'moment'
var CSV = require("xlsx");
import { useToast } from "primevue/usetoast";
import Switchin from './Switchin.vue'
import SwitchinCaricati from './SwitchinCaricati.vue'
import TIMOE_TIMG from './TIMOE_TIMG.vue'
import { useStore } from 'vuex'

export default {
  components: {
    Loader,
    Switchin,
    SwitchinCaricati,
    TIMOE_TIMG
  },
  
  setup (props, {emit}) { 
    const toast = useToast();
    const loading = ref(false)
    const activeTabIndex = ref(0)
    const activeTabIndexMethod = ref(0)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const countIvPod = ref(0)
    const countIvPdr = ref(0)
    const countPrecheckPod = ref(0)
    const countPrecheckPdr = ref(0)
    const countPreSwitchPod = ref(0)
    const countPreSwitchPdr = ref(0)
    const filename = ref('')
    const types = ref([
      {name:'ee', description: 'Energia'},
      {name:'gas', description: 'Gas'}
    ]);
    const router = useRouter()
    const allowedType = {
      'csv' : 'csv'
    }
    const ids = ref([])
    const keyInputReset = ref(0)
    const filePKToUpload = ref([])
    const fileIVToUpload = ref([])
    const headingsIV = ["COD_SERVIZIO", "COD_FLUSSO", "PIVA_UTENTE", "PIVA_GESTORE", "CP_UTENTE", "CP_GESTORE", "VERIFICA_AMM", "COD_CAUSALE", "MOTIVAZIONE", "COD_POD", "STATO_POD", "PMA_POD", "TENSIONE", "TOPONIMO", "VIA", "CIV", "CAP", "ISTAT", "LOCALITA", "PROV", "NAZIONE", "ALTRO", "MERCATO_PROVENIENZA", "POTCONTRIMP", "POTDISP", "CRPP_F1_AAM", "CRPP_F2_AAM", "CRPP_F3_AAM", "CRPP_F1_AAM1", "CRPP_F2_AAM1", "CRPP_F3_AAM1", "DATA_DECORRENZA_SW", "DATA_DECORRENZA_VT_TIT_III", "DATA_DECORRENZA_VT_TIT_IV"]
    const headingsIVG = ["COD_SERVIZIO", "COD_FLUSSO", "PIVA_UTENTE", "PIVA_GESTORE", "CP_UTENTE", "CP_GESTORE", "VERIFICA_AMM", "COD_CAUSALE", "MOTIVAZIONE", "COD_PDR", "COD_REMI", "STATO_PDR", "PIVA_DISTRIBUTORE", "TOPONIMO", "VIA", "CIV", "CAP", "ISTAT", "LOCALITA", "PROV", "NAZIONE", "ALTRO", "PREL_ANNUO_PREV", "COD_PROF_PREL_STD", "CAP_TRASP_PDR", "MATR_MIS", "CLASSE_GRUPPO_MIS", "TELEGESTIONE", "MERCATO_PROVENIENZA", "DATA_DECORRENZA_SWG", "DATA_DECORRENZA_VTG_TIT_III", "DATA_DECORRENZA_VTG_TIT_IV"]
    const headingsPK = ["COD_SERVIZIO", "COD_FLUSSO", "PIVA_VENDITORE", "PIVA_GESTORE", "CP_VENDITORE", "CP_GESTORE", "VERIFICA_AMM", "COD_CAUSALE", "MOTIVAZIONE", "ESITO", "COD_ESITO", "DETTAGLIO_ESITO", "COD_POD", "CF", "PIVA", "CF_STRANIERO", "DATA_SALVAGUARDIA", "CRPP_MM_F1", "CRPP_MM_F2", "CRPP_MM_F3", "CRPP_MM1_F1", "CRPP_MM1_F2", "CRPP_MM1_F3", "RISOLUZIONE_CONTRATTUALE_TIMOE", "PIVA_CONTROPARTE_COMMERCIALE", "RAG_SOC_CONTR_COMM", "EMAIL_CONTR_COMM", "PMA_POD"]
    const headingsPKG = ["COD_SERVIZIO", "COD_FLUSSO", "PIVA_VENDITORE", "PIVA_GESTORE", "CP_VENDITORE", "CP_GESTORE", "VERIFICA_AMM", "COD_CAUSALE", "MOTIVAZIONE", "ESITO", "COD_ESITO", "DETTAGLIO_ESITO", "COD_PDR", "COD_REMI", "TIPO_PDR", "PIVA_DISTRIBUTORE", "STATO_PDR", "CAP_TRASP_PDR", "CF", "PIVA", "CF_STRANIERO", "NOME", "COGNOME", "RAGIONE_SOCIALE", "RAGIONE_SOCIALE_CONTROPARTECOMMERCIALE", "PIVA_CONTROPARTECOMMERCIALE", "POSTA_CERTIFICATA", "PREL_ANNUO_PREV", "COD_PROF_PREL_STD", "CLASSE_GRUPPO_MIS", "TIPO_MIS", "TELEGESTIONE", "PRE_CONV"]

    const downloadedIv = ref(false)
    const downloadedPk = ref(false)
    const downloadedPs = ref(false)
    const id_pratica_iv = ref('')
    const id_pratica_iv_insert = ref([])

    const id_pratica_pk = ref('')
    const id_pratica_pk_insert = ref([])

    const itemsIv = ref()
    const itemsPk = ref()
    const itemsPs = ref()
    const ids_richiesta = ref([])

    const submitted = ref(false)
    const fileUploadKeyIV = ref(0);
    const fileUploadKeyPK = ref(0);
    const store = useStore()
    const currentUser = ref(store.state.auth.user)

    onMounted(() => {
      mount() 
    })
    
    const mount = () => {
      loading.value = true
      const promises = [
        getCountSupplyForPrecheck('ee'),
        getCountSupplyForPrecheck('gas'),
        getCountSupplyForPreSwitch('ee'),
        getCountSupplyForPreSwitch('gas'),
        getCountSupplyForIV('ee'),
        getCountSupplyForIV('gas'),
        getActivePratiche()
      ]
      // if (currentUser.value.profile.name == 'admin') {
      //   promises.push(getCountSupplyForPrecheck('ee'))
      //   promises.push(getCountSupplyForPrecheck('gas'))
      // }
      Promise.all(promises).finally(()=>{
        loading.value = false
      })
    }

    const getActivePratiche = async () => {
      await service.getPratiche().then((res)=>{
        res.items.forEach(pratica => {
          ids_richiesta.value.push(pratica.id_richiesta)
        });
        itemsIv.value = res.items.filter(el => el.filename.startsWith('IV'))
        itemsPk.value = res.items.filter(el => el.filename.startsWith('PK'))
        itemsPs.value = res.items.filter(el => el.filename.startsWith('PS'))
      })
    }
    const getCountSupplyForIV = async (type) => {
      await service.getCountSupplyForIV(type)
      .then((res) => {
        if (type == 'ee') {
          countIvPod.value = res.items
        } else {
          countIvPdr.value = res.items
        }
      })
    }
    const saveIdPratica = (type_pratica, file = null, id = null, index = null) => {
      let id_pratica
      loading.value = true

      switch (type_pratica) {
        case 'iv':
          id_pratica = file ? id : id_pratica_iv.value
          break;
        case 'pk':
          id_pratica = file ? id : id_pratica_pk.value
          break;
      }

      if (ids_richiesta.value.includes(id_pratica)) {
        loading.value = false
        toast.add({severity:'warn', summary:'Associazione non riuscita', detail: `ID di Richiesta già utilizzato`, life: 10000});
        if (file) {
          switch (type_pratica) {
            case 'iv':
              delete id_pratica_iv_insert.value[index]
              break;
            case 'pk':
              delete id_pratica_pk_insert.value[index]
              break;
          }
        } else {
          switch (type_pratica) {
            case 'iv':
              id_pratica_iv.value = ''
              break;
            case 'pk':
              id_pratica_pk.value = ''
              break;
          }          
        }
        return
      }

      let severity = 'success'
      let summary = 'Associazione eseguita'
      let detail = `${file ?? filename.value} è stato associato all'id ${id_pratica}`

      service.saveIdPratica(file ?? filename.value, id_pratica)
      .then((res)=>{
        loading.value = false
        if (!res) {
          severity = 'warn'
          summary = 'Associazione non riuscita'
          detail = `${file ?? filename.value} non è stato associato all'id ${id_pratica}`
        }
        toast.add({severity:severity, summary:summary, detail: detail, life: 10000});
      })
      .finally(()=>{
        getActivePratiche()
        if (type_pratica == 'iv') {
          id_pratica_iv.value = ''
          downloadedIv.value = false
        } else {
          id_pratica_pk.value = ''
          downloadedPk.value = false         
        }
      })
    }
    const getCountSupplyForPrecheck = async (type) => {
      await service.getCountSupplyForPrecheck(type).then((res) => {
        if (type == 'ee') {
          countPrecheckPod.value = res.items          
        } else {
          countPrecheckPdr.value = res.items          
        }
      })
    }
    const getCountSupplyForPreSwitch = async (type) => {
      await service.getCountSupplyForPreSwitch(type).then((res) => {
        if (type == 'ee') {
          countPreSwitchPod.value = res.items          
        } else {
          countPreSwitchPdr.value = res.items          
        }
      })
    }
    const goToCaricamenti = () => {
      router.push({path: '/caricamenti-multisito'})
    }
    const removeFile = (type) => {
      keyInputReset.value = new Date()
      if (type == 'pk') {
        filePKToUpload.value = []
      } else {
        fileIVToUpload.value = []
      }
    }
    const uploadResponsePratica = async (event, id, type, supply = null, swo = false) => {
      submitted.value = true
      let filename = event.files[0].name.replace('risposte_','')
      let id_file = filename.replace('.csv','')      
      if (id_file == id) {
        eval(`file${type.toUpperCase()}ToUpload`).value = [event.files[0]]
        if (await validateFile(type, supply)) {
          loading.value = true
          service.uploadPraticaFile(eval(`file${type.toUpperCase()}ToUpload`).value, id, type, supply, swo)
          .then((res)=>{
            if (res) {
              toast.add({severity:'success', summary:'Importazione eseguita', detail: `Elaborazione del file di risposta eseguita correttamente`, life: 10000});
            } else {
              toast.add({severity:'warn', summary:'Importazione fallita', detail: `Elaborazione del file di risposta non riuscita`, life: 10000});
            }
            eval(`file${type.toUpperCase()}ToUpload`).value = []
          })
          .finally(()=> {
            mount()
          })
        }
      }else{
        toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non corrisponde alla richiesta selezionata`, life: 10000});
        eval(`fileUploadKey${type.toUpperCase()}`).value++;
      }
    }
  // const uploadResponseIV = async (event,id) => {
    //   submitted.value = true
    //   let filename = event.files[0].name.replace('risposte_','')
    //   let id_file = filename.replace('.csv','')
    //   if (id_file == id) {
    //     fileIVToUpload.value = [event.files[0]]
    //     if (await validateFile('iv')) {
    //       loading.value = true
    //       service.uploadIvFile(fileIVToUpload.value, id)
    //       .then((res)=>{
    //         if (res) {
    //           toast.add({severity:'success', summary:'Importazione eseguita', detail: `Elaborazione del file di risposta eseguita correttamente`, life: 10000});
    //         } else {
    //           toast.add({severity:'warn', summary:'Importazione fallita', detail: `Elaborazione del file di risposta non riuscita`, life: 10000});
    //         }
    //         fileIVToUpload.value = []
    //       })
    //       .finally(()=> {
    //         getActivePratiche()
    //         loading.value = false
    //       })
    //     }
    //   }else{
    //     toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non corrisponde alla richiesta selezionata`, life: 10000});
    //     fileUploadKeyIV.value++;
    //   }
    // }

    // const uploadResponsePrecheck = async (event, id, supply) => {
    //   submitted.value = true
    //   let filename = event.files[0].name.replace('risposte_','')
    //   let id_file = filename.replace('.csv','')
    //   if (id_file == id) {
    //     filePKToUpload.value = [event.files[0]]
    //     if (await validateFile('pk', supply)) {
    //       loading.value = true
    //       service.uploadPrecheckFile(filePKToUpload.value, id, supply)
    //       .then((res)=>{
    //         if (res) {
    //           toast.add({severity:'success', summary:'Importazione eseguita', detail: `Elaborazione del file di risposta eseguita correttamente`, life: 10000});
    //         } else {
    //           toast.add({severity:'warn', summary:'Importazione fallita', detail: `Elaborazione del file di risposta non riuscita`, life: 10000});
    //         }
    //         filePKToUpload.value = []
    //       })
    //       .finally(()=> {
    //         getActivePratiche()
    //         loading.value = false
    //       })
    //     }
    //   }else{
    //     toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non corrisponde alla richiesta selezionata`, life: 10000});
    //     fileUploadKeyPK.value++;
    //   }
    // }    

    const downloadIvFile = async (type, file = null) => {
      loading.value = true
      if (file) {
        await service.downloadFileName(file)
        .finally(()=> {
          getCountSupplyForIV(type)
          loading.value = false
        })
      } else {
        filename.value = await service.downloadIvFile(type)
        .finally(()=> {
          getCountSupplyForIV(type)
          loading.value = false
          downloadedIv.value = true
        })        
      }
    }
    const downloadResponseIvFile = async (event,id) => {
      loading.value = true
      filename.value = await service.downloadResponseIvFile(id)
      .finally(()=> {
        loading.value = false
      })
    }
    const downloadResponsePrecheckFile = async (event,id, supply) => {
      loading.value = true
      filename.value = await service.downloadResponsePrecheckFile(id, supply)
      .finally(()=> {
        loading.value = false
      })
    }

    const downloadPrecheckFile = async (type, file = null) => {
      loading.value = true
      if (file) {
        await service.downloadFileName(file)
        .finally(()=> {
          getCountSupplyForPrecheck(type)
          loading.value = false
        })
      }else{
        filename.value = await service.downloadPrecheckFile(type)
        .finally(()=> {
          getCountSupplyForPrecheck(type)
          loading.value = false
          downloadedPk.value = true
        })        
      }
    }
    const downloadPreSwitchFile = async (type, file = null) => {
      loading.value = true
      if (file) {
        await service.downloadFileName(file)
        .finally(()=> {
          getCountSupplyForPreSwitch(type)
          loading.value = false
        })
      }else{
        filename.value = await service.downloadPreSwitchFile(type)
        .finally(()=> {
          getCountSupplyForPreSwitch(type)
          loading.value = false
          downloadedPs.value = true
        })        
      }
    }
    const handleFileUpload = (evt, type) => {
      filePKToUpload.value = []
      fileIVToUpload.value = []
      evt.preventDefault()
      submitted.value = false;
      if (type == 'pk') {
        filePKToUpload.value = self.refs.filePK.files
      } else {
        fileIVToUpload.value = self.refs.fileIV.files
      }
    }
    const validateFile = async (check, supply = null)  => {
      if (check == 'iv') {
        if (fileIVToUpload.value.length > 0) {
          const data = await fileIVToUpload.value[0].arrayBuffer();
          const workbook = CSV.read(data);
          let first_sheet_name = workbook.SheetNames[0];
          let ws = workbook.Sheets[first_sheet_name];
          const headers = (CSV.utils.sheet_to_json(ws, { header: 1 }))[0];
          const isSameHeaders = JSON.stringify(headers) === JSON.stringify(supply == 'Gas' ? headingsIVG : headingsIV);
          if (!isSameHeaders) {
            toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non è conforme con la richiesta selezionata`});
            fileUploadKeyIV.value++;

            return false
          }else{
            return true
          }
        }
      }else{
        if (filePKToUpload.value.length > 0) {
          const data = await filePKToUpload.value[0].arrayBuffer();
          const workbook = CSV.read(data);
          let first_sheet_name = workbook.SheetNames[0];
          let ws = workbook.Sheets[first_sheet_name];
          let headers = (CSV.utils.sheet_to_json(ws, { header: 1 }))[0];
          
          if (supply != 'Gas' && !headers.includes("PMA_POD")) {
            headers.push("PMA_POD")
          }
          const isSameHeaders = JSON.stringify(headers) === JSON.stringify(supply == 'Gas' ? headingsPKG : headingsPK);
          
          if (!isSameHeaders) {
            toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non è conforme con la richiesta selezionata`});
            fileUploadKeyPK.value++;

            return false
          } else{
            return true
          }
        }
      }
    }

    return {
      loading,
      activeTabIndex,
      activeTabIndexMethod,
      downloadIvFile,
      countIvPod,
      countIvPdr,
      allowedType,
      handleFileUpload,
      filePKToUpload,
      fileIVToUpload,
      keyInputReset,
      removeFile,
      uploadResponsePratica,
      downloadPrecheckFile,
      downloadPreSwitchFile,
      countPrecheckPod,
      countPrecheckPdr,
      countPreSwitchPod,
      countPreSwitchPdr,
      types,
      filename,
      downloadedIv,
      downloadedPk,
      downloadedPs,
      id_pratica_iv,
      id_pratica_iv_insert,
      id_pratica_pk,
      id_pratica_pk_insert,
      saveIdPratica,
      getActivePratiche,
      itemsIv,
      itemsPk,
      itemsPs,
      fileUploadKeyIV,
      fileUploadKeyPK,
      downloadResponseIvFile,
      downloadResponsePrecheckFile,
      moment,
      currentUser
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.gestisci-pratica {
  font-family: 'Montserrat', sans-serif;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 1.5rem;
}

.header-section {
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.page-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.subtitle {
  color: #7f8c8d;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.main-content {
  flex: 1;
}

.card-container {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.tab-container {
  padding: 0;
}

.tab-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.tab-title {
  font-weight: 600;
  white-space: nowrap;
  margin-right: 0.5rem;
}

.badge-container {
  display: flex;
  align-items: center;
}

.badge-separator {
  font-weight: 600;
  white-space: nowrap;
  margin: 0 0.25rem;
}

.tab-content {
  padding: 1.5rem;
}

.download-section {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.download-card {
  flex: 1;
  min-width: 250px;
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.download-button {
  min-width: 220px;
  padding: 0.8rem 1.5rem;
  font-weight: 500;
}

.file-info {
  margin: 2rem 0;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.file-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.file-name {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.input-section {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 250px;
}

.input-label {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #7f8c8d;
}

.input-mask {
  width: 100%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.action-button {
  margin-top: 0.5rem;
}

.data-table-section {
  margin-top: 2rem;
}

.section-header {
  background-color: #f8f9fa;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 1rem;
}

.section-header h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #3498db;
  margin: 0;
}

.custom-datatable {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.empty-message {
  padding: 2rem;
  text-align: center;
  color: #7f8c8d;
}

.file-button {
  font-size: 0.8rem !important;
  padding: 0.3rem 0.6rem !important;
  max-width: fit-content;
}

.file-name-text {
  margin: 0;
  font-size: 0.9rem;
}

.pdp-count {
  margin: 0;
  font-weight: 500;
}

.date-value {
  font-size: 0.9rem;
  color: #2c3e50;
}

.id-input {
  max-width: 5rem;
  font-size: 0.9rem;
}

.id-value {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 500;
}

.status-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
}

.status-icon.completed {
  color: #4caf50;
}

.status-icon.pending {
  color: #f44336;
}

.upload-button {
  font-size: 0.8rem !important;
  max-width: fit-content;
}

.download-result-button {
  font-size: 0.8rem !important;
  max-width: fit-content;
}

.save-id-button {
  font-size: 0.8rem !important;
  max-width: fit-content;
}

@media (max-width: 768px) {
  .download-section {
    flex-direction: column;
  }

  .file-details {
    align-items: stretch;
  }

  .input-section {
    max-width: 100%;
  }
}
</style>